<style lang="scss" scoped>
@import "core";

#pg-app {
  margin: 30px 0;
}

.pg-tab-year-pos {
  display: inline-block;
}

.pg-tab-year {
  @include mq('xs') {
    font-size: 90%;
  }
}
</style>



<template>
  <div id="pg-app">
    <dn-tabs id="pg-years" v-model="selected" v-if="years">
      <dn-tabs-bar slot="activators">
        <dn-tabs-item
          v-for="year in years"
          :key="year"
          :href="'#pg-years-' + year"
          class="pg-tab-year"
        >{{year}}年度<span class="pg-tab-year-pos">入試</span></dn-tabs-item>
      </dn-tabs-bar>

      <dn-tabs-content
        v-for="year in years"
        :key="year"
        :id="'pg-years-' + year"
      ><dn-pg-year :year="year" /></dn-tabs-content>
    </dn-tabs>
  </div>
</template>



<script>
import Year from './Year';



export default {
  name: 'dn-bible-self-app',

  components: {
    'dn-pg-year': Year,
  },



  data() {
    return {
      // baseYear: null,
      selected: this.$route.query.year ? `pg-years-${this.$route.query.year}` : null,
    }
  },



  computed: {
    baseYear() { return this.$store.getters['config/year'] },
    years() {
      if (!this.baseYear) return;
      const years = [];
      for (let i = 0; i < 3; i++) {
        years.push(this.baseYear - i  - 1);
      }
      return years;
    },
  },
}
</script>



// WEBPACK FOOTER //
// App.vue?6f07c9be